export const questions =
{
    path: "/questions",
    component: () => import("@/views/quertionsAndAnswer/questions.vue"),
    meta: {
        hidden: false,
    },
}
export const questionsDetails =
{
    path: "/questionsDetails",
    component: () => import("@/views/quertionsAndAnswer/questionsDetails.vue"),
    meta: {
        hidden: false,
    },
}
export const answer =
{
    path: "/answer",
    component: () => import("@/views/quertionsAndAnswer/answer.vue"),
    meta: {
        hidden: false,
    },
}
export const answerDetails =
{
    path: "/answerDetails",
    component: () => import("@/views/quertionsAndAnswer/answerDetails.vue"),
    meta: {
        hidden: false,
    },
}
export const askingQuestions =
{
    path: "/askingQuestions",
    component: () => import("@/views/quertionsAndAnswer/askingQuestions.vue"),
    meta: {
        hidden: false,
    },
}
export const reply =
{
    path: "/reply",
    component: () => import("@/views/quertionsAndAnswer/reply.vue"),
    meta: {
        hidden: false,
    },
}
export const userQuestionsAnswer =
{
    path: "/userQuestionsAnswer",
    component: () => import("@/views/quertionsAndAnswer/userQuestionsAnswer.vue"),
    meta: {
        hidden: false,
    },
}
export const search =
{
    path: "/search",
    component: () => import("@/views/quertionsAndAnswer/search.vue"),
    meta: {
        hidden: false,
    },
}